import { Star, Quote } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { useLanguage } from "@/context/LanguageContext";

export const TestimonialsSection = () => {
  const { t } = useLanguage();

  const testimonials = t.testimonials.items;

  return (
    <section data-testid="testimonials-section" className="py-24 bg-gradient-to-b from-white to-[#F3F0E7]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="text-[#C89D4B] font-semibold uppercase tracking-widest text-sm">{t.testimonials.title}</span>
          <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl font-bold text-[#1A2332] mt-3">
            {t.testimonials.subtitle}
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((item) => (
            <Card
              key={item.name}
              data-testid={`testimonial-${item.name}`}
              className="border-0 shadow-lg hover:shadow-xl transition-all hover:-translate-y-1 bg-white relative overflow-hidden"
            >
              <CardContent className="p-8">
                <Quote className="w-8 h-8 text-[#C89D4B]/30 mb-4" />
                <p className="text-[#4A5568] leading-relaxed mb-6 italic">
                  "{item.text}"
                </p>
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 bg-gradient-to-br from-[#003A4B] to-[#1B5E6B] rounded-full flex items-center justify-center text-white font-bold text-lg">
                    {item.name.charAt(0)}
                  </div>
                  <div>
                    <p className="font-semibold text-[#1A2332]">{item.name}</p>
                    <p className="text-sm text-[#718096]">{item.relation}</p>
                  </div>
                </div>
                <div className="flex gap-1 mt-4">
                  {[1, 2, 3, 4, 5].map((i) => (
                    <Star key={i} className="w-4 h-4 fill-[#C89D4B] text-[#C89D4B]" />
                  ))}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};
